import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
// 核心插件
import Admin from '@/plugin/admin'
// store
import store from '@/store'
import { frameInRoutes } from '@/router/routes'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import router from './router'

import uploader from 'vue-simple-uploader'

import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'

Vue.use(Admin)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
}) // 默认配置写法
Vue.use(uploader)

Vue.use(VueAwesomeSwiper)

const render = () => {
  return new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    created () {
      // 处理路由 得到每一级的路由设置
      this.$store.commit('admin/page/init', frameInRoutes)
    },
    mounted () {
      this.$store.dispatch('admin/system/load')
      this.$store.dispatch('admin/account/load')
    }
  }).$mount('#app')
}

if (window.__POWERED_BY_WUJIE__) {
  let instance
  window.__WUJIE_MOUNT = () => {
    instance = render()
  }
  window.__WUJIE_UNMOUNT = () => {
    instance.$destroy()
    instance.$el.innerHTML = ''
    instance = null
  }
} else {
  render()
}

